export default __webpack_public_path__ + "static/media/img-3830.3c69d697.jpeg";